import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Response } from "@shared/interfaces/response/response";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class SimuladorService {

    private baseURL = environment.apiBaseUrl;
    private commonUrl = this.baseURL + "api/Simulador";

    constructor(private http: HttpClient) {}

    getTerm(promocion: string) {
        const url = `${this.commonUrl}/term/${promocion}`;
        return this.http.get<Response>(url);
    }

    getCicle(promocion: string) {
        const url = `${this.commonUrl}/cicle/${promocion}`;
        return this.http.get<Response>(url);
    }

    getProDefiniciones() {
        const url = `${this.baseURL}api/parametria/portafolio/ProDefiniciones/prodefgasvalores/29`;
        return this.http.get<Response>(url);
    }

    getPromocionesPlazos(promocion: string, numvar: number) {
        const url = `${this.baseURL}api/promociones/plazos/${promocion}/${numvar}`;
        return this.http.get<Response>(url); 
    }

    AmortizacionValoresSimula(request :any) : Observable<any> {
        return this.http.post<any>(environment.apiBaseUrl + "api/RenegociacionCreditos/AmortizacionValoresSimula",request);
    }

    AmortizacionSimulaPromocion(request :any) : Observable<any> {
        return this.http.post<any>(environment.apiBaseUrl + "api/RenegociacionCreditos/AmortizacionSimulaPromocion",request);
    }

    SimulaPromocion(request: any): Observable<any> {
        return this.http.post<any>(environment.apiNewBackBaseUrl + "Solicitudes/SimulaPromocion", request);
    }

    AmortizacionSimulaEfectivo(request :any) : Observable<any> {
        return this.http.post<any>(environment.apiBaseUrl + "api/RenegociacionCreditos/AmortizacionSimulaEfectivo",request);
    }

    AmortizacionSimulaComision(request :any) : Observable<any> {
        return this.http.post<any>(environment.apiBaseUrl + "api/RenegociacionCreditos/AmortizacionSimulaComision",request);
    }
    
}
